import { createRoutingProjectModel, createRoutingProjectPlanModel } from 'features/RoutingProjects/models'
import { IRoutingProjectModel, IRoutingProjectPlansCollection } from 'features/RoutingProjects/types'
import { RoutingProjectFragment, RoutingProjectPlanFragment } from 'gql/generated/graphql'

export interface IRoutingProjectsCollection {
  items: IRoutingProjectModel[]
  isEmpty: boolean
}

export const createRoutingProjectsCollection = (items: RoutingProjectFragment[]): IRoutingProjectsCollection => {
  return {
    items: items.map((item) => createRoutingProjectModel(item)),
    isEmpty: items.length === 0
  }
}

export const createRoutingProjectPlanCollection = (
  plans: RoutingProjectPlanFragment[]
): IRoutingProjectPlansCollection => {
  const items = plans.map((plan) => createRoutingProjectPlanModel(plan))
  return {
    items,
    isEmpty: plans.length === 0,
    filter: (fn) => items.filter(fn),
    length: plans.length
  }
}
